import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { log } from "@/utils/log";

/**
 * Custom hook to handle scroll-to-top behavior for SPA navigation
 * Ensures all pages load at the top when navigating or refreshing
 */
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top with proper error handling
    const scrollToTop = () => {
      try {
        // Use requestAnimationFrame for better performance
        requestAnimationFrame(() => {
          // Reset scroll position to absolute top
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto' // Instant scroll for route changes
          });

          // Fallback for older browsers
          if (window.scrollY !== 0) {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          }
        });
      } catch (error) {
        log.warn('Scroll to top failed:', error);
        // Fallback method
        window.scrollTo(0, 0);
      }
    };

    // Execute scroll with slight delay to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.key]); // Include location.key for same-route navigation

  // Return current pathname for debugging
  return location.pathname;
};